import React from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import { RiFacebookLine } from "react-icons/ri";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="social">
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"><RiFacebookLine /></a>
         <a href="https://t.me/udt555" target="_blank" rel="noopener noreferrer"><FaTelegramPlane /></a>
      </div>
      <p>Copyright@2026: UDT 555 all rights reserved</p>
    </div>
  );
};

export default Footer;
